// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1XAKI","inputWrap":"Table_inputWrap__cB3Fe","col":"Table_col__30N1U","bmiTooltip":"Table_bmiTooltip__2vrGO"};